import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';

// Read-only - one row per AI analysis attempt (success or failure, including
// retries) - see database/models/analysis_report_ai_usage.py. No
// popupComponent: the model's can_create/can_update/can_delete are all False
// server-side, so the generic List component already hides New/edit/delete
// controls for this tab (see coda_frontend/src/core/components/Repository/List.js).
const AnalysisReportAiUsageList=({parentId,application,userData,parent})=>{
    const list_name='analysis_report_ai_usage';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'AnalysisReportAiUsage'}
                entityParams={['analysis_report_id='+parentId]}
                list_name={list_name}
                height={'50vh'}
                file={'AnalysisReportAiUsageList.js'}
                navigateOnNew={null}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                parentContext={{
                    parent_field_name:'analysis_report_id',
                    parent_field_value:null,
                    parent_name:'AnalysisReport',
                }}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return renderListTab;
}
export default AnalysisReportAiUsageList;
